import { render } from "./bubble.vue?vue&type=template&id=ca0044be"
import script from "./bubble.vue?vue&type=script&lang=js"
export * from "./bubble.vue?vue&type=script&lang=js"

import "./bubble.vue?vue&type=style&index=0&id=ca0044be&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__